import {useTranslation} from 'react-i18next';

export const useRegulationFormTranslation = () => {
	return useTranslation('features/regulations', {
		keyPrefix: 'RegulationsForm',
	});
};
